import { render, staticRenderFns } from "./PesquisaLivre.vue?vue&type=template&id=62cb91bf&scoped=true&"
import script from "./PesquisaLivre.vue?vue&type=script&lang=js&"
export * from "./PesquisaLivre.vue?vue&type=script&lang=js&"
import style0 from "./PesquisaLivre.vue?vue&type=style&index=0&id=62cb91bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb91bf",
  null
  
)

export default component.exports